import React from 'react';
import { useTranslation } from '../../../../context/LanguageContext';
import SelectField from '../../../form/SelectField';
import InputField from '../../../form/InputField';

const InterfaceTab = ({ settings, handleChange, handleLanguageChange }) => {
    const { t, isRTL } = useTranslation();

    return (
        <div className="space-y-6">
            <div className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className={`text-lg font-semibold text-gray-800 mb-6 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('admin.interfaceConfig')}
                </h3>
                <div className="grid grid-cols-1 gap-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <SelectField
                            label={t('admin.defaultLanguage')}
                            value={settings.interface.default_language}
                            onChange={handleLanguageChange}
                            options={[
                                { value: 'en', label: t('admin.english') },
                                { value: 'ar', label: t('admin.arabic') }
                            ]}
                        />
                        <SelectField
                            label={t('admin.itemsPerPage')}
                            value={settings.interface.items_per_page}
                            onChange={(e) => handleChange('interface', 'items_per_page', e.target.value)}
                            options={[
                                { value: '10', label: '10' },
                                { value: '25', label: '25' },
                                { value: '50', label: '50' }
                            ]}
                        />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <InputField
                            label={t('admin.currencySymbol')}
                            value={settings.interface.currency_symbol}
                            onChange={(e) => handleChange('interface', 'currency_symbol', e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InterfaceTab;
